import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconListSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"list-sparkle, ai text, text generation"} maskId="square-filled-radius-0-stroke-1-IconListSparkle"><path d="M3 5V6H21V5H3Z" fill="currentColor"/><path d="M17 9.38197L15.1273 13.1273L11.382 15L15.1273 16.8727L17 20.618L18.8727 16.8727L22.618 15L18.8727 13.1273L17 9.38197Z" fill="currentColor"/><path d="M3 11.5V12.5H10V11.5H3Z" fill="currentColor"/><path d="M3 18V19H8V18H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconListSparkle;
